import Plugin from '../core/Plugin';
import axios from 'axios';
import { appendChild, createElement, removeFromParent, addStyle, clearAllNode } from '../utils/Dom';
import { PlayerEvent } from './../PlayerEvents';
import { isMobile } from '../utils/util';
import log from 'loglevel';
import './css/VodMultiSubtitle.css';

/**
 *
 *
 * @export
 * @class VodMultiSubtitle
 * @extends {Plugin}
 */
export default class VodMultiSubtitle extends Plugin {
  constructor() {
    super();
    this.CLASS_NAME = this.constructor.name;
    this.currentSubtitle = null;
    this.srtMap = [];
  }

  init(opts = {}) {
    super.init(opts);
    if (opts.isLive) {
      return;
    }

    /** 
      subtitle_info: {
        "srt": [
          {
            "lang": "zh",
            "is_default": 1,
            "remark": "伪直播1",
            "url": "https://t-alioss01.e.vhall.com/vhallyun/vhallsubtitle/862a013b/subtitle_zh.srt"
          },
          {
            "lang": "en",
            "is_default": 0,
            "remark": "伪直播2",
            "url": "https://t-alioss01.e.vhall.com/vhallyun/vhallsubtitle/862a013b/subtitle_en.srt"
          }
        ]
      }
    */
    this._allConfig = opts;
    this._subtitleCfg = JSON.parse(opts[VodMultiSubtitle.type]);
    const subtitleCfg = this._subtitleCfg;
    this._defineMethods();
    if (subtitleCfg.enable === false) {
      return;
    }
    log.info('启用点播字幕');

    //todo: 自定义样式
    //参考：https://developer.mozilla.org/zh-CN/docs/Web/CSS/::cue
    const subtitleStyle = subtitleCfg['style'];
    if (subtitleStyle && Object.keys(subtitleStyle).length > 0) {
      const video = this.player.getVideo();
      if (video) {
        Object.keys(subtitleStyle).forEach((key, index) => {
          video.style.setProperty('--' + key, subtitleStyle[key]);
        });
      }
    }
    this._pretreatment();
    this._handleCareEvent();
  }

  _defineMethods() {
    this.player.openVodSubtitle = this._openVodSubtitle.bind(this);
    this.player.closeVodSubtitle = this._closeVodSubtitle.bind(this);
    this.player.getCurrentVodSubtitle = this._getCurrentVodSubtitle.bind(this);
    this.player.getVodSubtitleList = this._getVodSubtitleList.bind(this);
    this.player.switchVodSubtitle = this._switchVodSubtitle.bind(this);
    this.player.reloadVodSubtitle = this._reloadVodSubtitle.bind(this);
  }

  _handleCareEvent() {
    this.player.on('fullscreenchanged', this._fullscreenChanged.bind(this));
    this.player.player.video.textTracks.onaddtrack = this._addtrackEvent.bind(this);
    this.player.player.video.textTracks.onchange = this._changeEvent.bind(this);
  }

  /**
   * todo: 加载成功处理
   * 参考：https://developer.mozilla.org/en-US/docs/Web/API/TextTrackList/addtrack_event
   */
  _addtrackEvent(event) {
    log.info(`TextTrackList.onaddtrack事件: ${event.track.label} added`);
    // todo: 修改字幕显示位置，必须修改合适的执行时机
    // const tracks = this.player.player.video.textTracks;
    // const track = tracks[0]
    // const track = event.track
    // Array.from(track.cues).forEach(c => {c.line=-3});
    // track.mode='hidden';
    // track.mode='showing';
  }

  /**
   * todo: 切换字幕处理
   * 参考：https://developer.mozilla.org/en-US/docs/Web/API/TextTrackList/change_event
   */
  _changeEvent(event) {
    // const track = event.track;
    // const isEnabled = (track.mode == "showing");
    // console.log(track, track.label, track.kind, track.type, isEnabled);
  }

  // 获取点播字幕文件并解析
  _pretreatment(isReload) {
    const subtitleInfo = this._subtitleCfg.subtitle_info;
    if (subtitleInfo && subtitleInfo['srt']) {
      const srtInfoArr = subtitleInfo['srt'];
      this.srtMap = srtInfoArr;
      // 下载字幕文件并解析
      let haveDefault = false;
      for (let i = 0; i < srtInfoArr.length; i += 1) {
        let srtInfo = srtInfoArr[i];
        srtInfo['index'] = i;
        srtInfo['isDefault'] = srtInfo['is_default'] === 1;
        delete srtInfo['is_default'];
        if (srtInfo['isDefault'] && !haveDefault) {
          this.currentSubtitle = srtInfo;
          haveDefault = true;
        }
      }
      if (!haveDefault) {
        srtInfoArr[0]['isDefault'] = true;
        this.currentSubtitle = srtInfoArr[0];
      }

      for (let i = 0; i < srtInfoArr.length; i += 1) {
        let srtInfo = srtInfoArr[i];
        const url = srtInfo['url'];
        this._fetchAndParseSubtitle(url).then(
          res => {
            srtInfo['innerUrl'] = res;
            this._appendSubtitle(srtInfo, this._subtitleCfg['auto']);
            // todo: 需要抛出事件，此处需处理

            // 字幕配置设为自动显示时
            if (this._subtitleCfg['auto'] && srtInfo['isDefault']) {
              this.player.isOpenVodSubtitle = true;
              this.player.emit2All(PlayerEvent.OPEN_SUBTITLE);
            }

            this.player.emit2All(PlayerEvent.VOD_SUBTITLE_MOUNTED, { isReload: !!isReload, ...srtInfo });
          },
          res => {
            // todo: 失败处理
          }
        );
      }
    }
  }

  // 下载字幕并统一转换url
  _fetchAndParseSubtitle(url) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${url}`)
        .then(res => {
          let text = res.data;
          // todo优化: event style
          const e = {
            url,
            text
          };
          // todo优化: 与创建实例与监听的时机，可能存在时间差，导致监听不到
          log.info(`点播字幕下载成功`);
          this.player.emit2All('vodSubtitleLoadedIn', e);
          const fileType = url.substring(url.lastIndexOf('.') + 1);
          if (fileType === 'srt') {
            text = this._srt2vtt(text);
          }
          const webvvtUrl = URL.createObjectURL(new Blob([text]));
          resolve(webvvtUrl);
        })
        .catch(res => {
          reject(res);
        });
    });
  }

  /**
   * srt转换vtt，参考https://cloud.tencent.com/document/product/436/85909
   */
  _srt2vtt(text) {
    const arr = text.split('\n');
    text = arr.slice(0, arr.length).join('\n');
    const vvtText = 'WEBVTT\n' + '\n' + text.replace(/,/g, '.') + '\n';
    return vvtText;
  }

  _appendSubtitle(trackInfo, auto) {
    if (this.player.player.video) {
      this.player.player.appendSubtitle(trackInfo, auto);
      log.info(`点播字幕挂载成功`);
    }
  }

  // 获取当前点播字幕信息
  _getCurrentVodSubtitle() {
    return this.currentSubtitle;
  }

  // 获取点播字幕列表
  // todo：等待加载成功？
  _getVodSubtitleList() {
    return this.srtMap;
  }

  // 开启点播字幕
  // 参考：https://developer.mozilla.org/en-US/docs/Web/API/TextTrack
  _openVodSubtitle(obj) {
    this.player.isOpenVodSubtitle = true;
    this.player.emit2All(PlayerEvent.OPEN_SUBTITLE);

    if (obj) {
      this.currentSubtitle = obj;
    }

    const tracks = this.player.player.video.textTracks;
    for (let i = 0; i < tracks.length; i += 1) {
      tracks[i].mode = 'disabled';
    }
    for (let i = 0; i < tracks.length; i += 1) {
      if (tracks[i].language == this.currentSubtitle.lang) {
        tracks[i].mode = 'showing';
      }
    }
  }

  // 关闭点播字幕
  _closeVodSubtitle() {
    this.player.isOpenVodSubtitle = false;
    this.player.emit2All(PlayerEvent.CLOSE_SUBTITLE);

    const tracks = this.player.player.video.textTracks;
    for (let i = 0; i < tracks.length; i += 1) {
      tracks[i].mode = 'disabled';
    }
  }

  /**
   * 重新载入点播字幕
   * @param {*} option
   * isOpen: 重新载入字幕后字幕开关,不传则使用初始配置项控制开关
   */
  async _reloadVodSubtitle(subtitleInfo) {
    this._subtitleCfg.subtitle_info = subtitleInfo;
    this._pretreatment(true);
  }

  // 切换点播字幕
  _switchVodSubtitle(obj) {
    this.currentSubtitle = obj;
    if (this.player.isOpenVodSubtitle) {
      const tracks = this.player.player.video.textTracks;
      for (let i = 0; i < tracks.length; i += 1) {
        tracks[i].mode = 'disabled';
      }
      for (let i = 0; i < tracks.length; i += 1) {
        if (tracks[i].language == this.currentSubtitle.lang) {
          tracks[i].mode = 'showing';
        }
      }
    }
    const e = {
      oldValue: JSON.parse(JSON.stringify(this.currentSubtitle)),
      newValue: obj
    };
    this.player.emit2All(PlayerEvent.SUBTITLE_CHANGED, e);
  }

  /**
   * 字体大小随屏幕变化
   */
  _fullscreenChanged(e) {
    if (!isMobile()) {
      if (e === 'normal') {
      } else if (e === 'fullscreen') {
      }
    } else {
      if (e === 'normal') {
      } else if (e === 'fullscreen') {
      }
    }
  }

  destroy() {
    super.destroy();
  }

  static get type() {
    return 'plugin_vodSubtitle';
  }
}
